module.exports = __webpack_public_path__ + "static/media/AngelsOfAether-Gallery-10.a4ff8fe7.jpg";